<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  const style = {
    input: "input w-100 ba b--black-10 bw1 br1 pa2",
    label: "db lato fw4 mb2 black tl",
    button: {
      enabled:
        "link bn pa3 ph4 bg-black white br1 f5 fw3 lato dim pointer tracked",
      disabled: "pa3 bn ph4 bg-black white br1 f5 fw3 lato o-20 tracked",
    },
  };

  let password = "";
  $: valid = password.length;

  const submit = async (e) => {
    e.preventDefault();
    dispatch("submit", "");
  };
</script>

<div class="bg-white pv4 pv6-ns ma4 mt5 ma6-ns mh7-l">
  <div class="w-90 w-60-ns w-30-l center tc">
    <h2 class="ma0 pa0 mb5 lora f2 black-80 bb bw2 b--green dib">
      Grandma's Pond
    </h2>
    <form name="password" on:submit|preventDefault={submit}>
      <div class="pa2">
        <label for="password" class={style.label}
          >Please enter a password to continue.</label
        >
        <input
          class={style.input}
          name="password"
          type="password"
          id="password"
          bind:value={password}
        />
      </div>
      <div class="pt4 tc">
        <button
          type="submit"
          disabled={!valid}
          class={valid ? style.button.enabled : style.button.disabled}
          >Submit</button
        >
      </div>
    </form>
  </div>
</div>

<style>
  .focus-black:focus {
    border-color: rgba(0, 0, 0, 0.6);
  }
</style>
